import { Model } from "@/models";
import ReportTemplateCompetitor from "./ReportTemplateCompetitor";

type TemplateUser = {
  id: number;
  email: string;
};

type TemplateProfile = {
  id: number;
  name: string;
  slug: string;
};

// Summary of an automatic report using this template, as emitted by ReportTemplateSerializer.
// Carries just enough recurrence to render `describeGranularity`.
export type LinkedAutomaticReport = {
  id: number;
  name: string;
  granularityKind: string;
  granularityQuantity?: number | null;
  granularityRange?: number[] | null;
  weekType?: string | null;
};

export default class ReportTemplate extends Model {
  static type = "reportTemplates";

  name?: string;
  kind?: string;
  visible?: boolean;

  user!: TemplateUser;
  profile!: TemplateProfile;
  competitor?: ReportTemplateCompetitor;

  automaticReports?: LinkedAutomaticReport[];
}
